module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/store_images/5_3df27880cc0d4580446b3f63c3c8ac25.png";